import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import translation from './locales/en'

i18next.use(initReactI18next).init({
  lng: 'en', // if you're using a language detector, do not define the lng option
  // Only emit i18next's verbose console output in dev; it spams the console in
  // production builds.
  debug: import.meta.env.DEV,
  resources: {
    en: {
      translation,
    },
  },
})
